const FILE_DESCRIPTION_MAX_LENGTH = 1000;

export default FILE_DESCRIPTION_MAX_LENGTH;
